import { lazyRenderWidgetByLoader, projectLoaders } from 'core-components/helpers/lazyLoad'
import { IWidgetSelector } from 'core-components/sitebuilder/models/IWidgetSelector'

projectLoaders['omnicom/'] = (path: string) => {
  const componentName = path.split('/').at(-1)

  if (path.startsWith('omnicom/components/widgets/EmailCampaigns/templateFilterArea/')) {
    return import(
      `omnicom/components/widgets/EmailCampaigns/templateFilterArea/${componentName}.tsx`
    )
  }

  return import(`omnicom/components/layout/${componentName}.tsx`)
}

export const WidgetSelector = (props: IWidgetSelector) => {
  const DocflowWidgetSelector = props.lazyWidgets?.DocflowWidgetSelector

  const widgetLoaders: Record<string, () => Promise<any>> = {
    'campaign-list': () => import('omnicom/components/widgets/EmailCampaigns/CampaignList'),
    'omnicom-vertical-tabs': () => import('omnicom/components/widgets/EmailCampaigns/VerticalTabs'),
    'campaigns-statistic': () =>
      import('omnicom/components/widgets/EmailCampaigns/CampaignStatistic'),
    'omnicom-template': () => import('omnicom/components/widgets/EmailCampaigns/DisplayTemplate'),
    'omnicom-template-table': () =>
      import('omnicom/components/widgets/EmailCampaigns/TemplateTable'),
    'omnicom-template-menu': () => import('omnicom/components/widgets/EmailCampaigns/TemplateMenu'),
    'omnicom-omniwidget': () => import('omnicom/components/widgets/Omni/MainPage'),
    'omnicom-template-settings': () =>
      import('omnicom/components/widgets/EmailCampaigns/TemplateSettings'),
    'omnicom-customize': () => import('omnicom/components/widgets/EmailCampaigns/CustomizePage'),
    'profile-widget': () => import('omnicom/components/widgets/OmniSheduler/ProfileWidget'),
    'signature-widget': () => import('omnicom/components/widgets/OmniSheduler/SignatureWidget'),
    'omnicom-sheduler': () => import('omnicom/components/widgets/OmniSheduler/OmniSheduler'),
    'pdl-management': () => import('omnicom/components/widgets/EmailCampaigns/PdlManagement'),
    'spoc-survey': () => import('omnicom/components/widgets/Survey/SurveyWidget'),
    'email-sending-block': () =>
      import('omnicom/components/widgets/EmailSending/templateBlock/TemplateBlock'),
    'templates-with-blocks': () =>
      import('omnicom/components/widgets/EmailSending/templates/Templates'),
    'email-sending-emails': () => import('omnicom/components/widgets/EmailSending/emails/Emails'),
    'email-sending-campaign': () =>
      import('omnicom/components/widgets/EmailSending/emailSettings/EmailSettings'),
    'campaign-analytics': () =>
      import('omnicom/components/widgets/CampaignAnalytics/CampaignAnalytics'),
    'campaign-insights': () =>
      import('omnicom/components/widgets/CampaignInsights/CampaignInsights'),
  }

  const widgetsWithMeta = [
    'omnicom-vertical-tabs',
    'campaigns-statistic',
    'omnicom-template',
    'omnicom-template-table',
    'omnicom-template-settings',
    'omnicom-customize',
    'email-sending-campaign',
    'campaign-insights',
  ]

  if (props.viewModel in widgetLoaders) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: widgetLoaders[props.viewModel],
      props: { ...props.props },
      loadMeta: widgetsWithMeta.includes(props.viewModel),
    })
  }

  return (DocflowWidgetSelector && DocflowWidgetSelector(props)) || <div>{props.viewModel}</div>
}
